import React from "react";
import { isSviObjectMapEvent } from "../../constants/dream.constants";
import { showDate, translateEventState } from "../../utils/event.utils";
import { isStationEvent } from "../../utils/station.utils";

export default function EventTooltip(props) {
	const { properties, subTypeEnabled, language, coordinates, buttons, embeddedApp, embeddedAppType, isMarker} = props;

	const isDreamEvent = isSviObjectMapEvent(properties.id);

	return (
		<span
			style={{
				width: "360px",
			}}>
			{isDreamEvent ? (
				<>
					<p key="objectId">
						<b>{language === "de" ? "Objekt-ID" : "Object ID"}:</b> {properties.objectId || "AB12345"}
					</p>
					<p key="objectName">
						<b>{language === "de" ? "Name des Objekts" : "Name of object"}:</b> {properties.objectName || "Residential area restoration"}
					</p>
					<p key="state">
						<b>{language === "de" ? "Status" : "State"}:</b> {properties.state || "active"}
					</p>
					<p key="type">
						<b>{language === "de" ? "Art" : "Type"}:</b> {properties.type || "residential"}
					</p>
					<p key="dateStart">
						<b>{language === "de" ? "Startdatum" : "Date of start"}:</b> {properties.dateStart || "01.01.2022"}
					</p>
					<p key="dateEnd">
						<b>{language === "de" ? "Enddatum" : "Date end"}:</b> {properties.dateEnd || "01.01.2027"}
					</p>
					<p key="fulfillment">
						<b>{language === "de" ? "Aktueller Erfüllungsgrad" : "Current % of fulfillment"}:</b> {properties.fulfillmentPercent || "85%"}
					</p>
					<p key="contractor">
						<b>{language === "de" ? "Auftragnehmer" : "Contractor"}:</b> {properties.contractor || "ABC company"}
					</p>
				</>
			) : (
				<>
					{!isStationEvent(properties) && (
						<p key={1}>
							<b>{language === "de" ? "Ereignis-ID" : "Event ID"}:</b> {properties.id}
						</p>
					)}
					<p key={2}>
						<b>{language === "de" ? "Orts-ID" : "Location ID"}:</b>{" "}
						{properties.locationId}
					</p>
				</>
			)}
			{
				"code" in properties ? <p key={15}>
				<b>{language === "de" ? "Code" : "Code"}:</b> {properties?.code}
			</p> : null}
			{
				"area" in properties ? <p key={16}>
				<b>{language === "de" ? "Area" : "Area"}:</b> {properties?.area}
			</p> : null}
			<p key={3}>
				<b>{language === "de" ? "Status" : "State"}:</b>{" "}
				{isMarker ? properties.state : translateEventState(properties.state, language)}
			</p>
			<p key={4}>
				<b>{language === "de" ? "Art" : "Type"}:</b> {properties.type}
			</p>
			{properties.pipeline && (
				<p key={17}>
					<b>{language === "de" ? "Pipeline" : "Pipeline"}:</b> {properties.pipeline}
				</p>
			)}
			<p hidden={!subTypeEnabled} key={5}>
				<b>{language === "de" ? "Art" : "Sub Type"}:</b> {properties.subType}
			</p>
			<p key={6}>
				<b>{language === "de" ? "Letztes Update" : "Last Updated"}:</b>{" "}
				{showDate(properties.date)}
			</p>
			{/* <p key={7}>
				<b>{language === "de" ? "Ort" : "Location"}:</b>{" "}
				{coordinates[0].toFixed(5)}, {coordinates[1].toFixed(5)}
			</p> */}
			{embeddedApp ? 
				<p key={7}>
					<b>{language === "de" ? "Ort" : "Location (lon/lat)"}:</b>{" "}
				{coordinates[0].toFixed(5)}, {coordinates[1].toFixed(5)}
				</p> : 
				<p key={7}>
					<b>{language === "de" ? "Ort" : "Location"}:</b>{" "}
				{coordinates[0].toFixed(5)}, {coordinates[1].toFixed(5)}
				</p>
			}
			{embeddedApp ? 
				<p key={8}>
					<b>Initial Description:</b>{" "}
					{properties.comment}
				</p> : 
				<p key={8}>
					<b>{language === "de" ? "Kommentar" : "Comment"}:</b>{" "}
					{properties.comment}
				</p>
			}
			
			<p key={9}>
				<b>{language === "de" ? "Autor" : "Author"}:</b> {properties.author}
			</p>
			{embeddedApp && properties.note ? <p key={10}>
				<b>Note:</b>{" "} {properties.note}
			</p> : null}
			
			
			<p hidden={!properties.markerName} key={11}>
				<b>{language === "de" ? "Leitung" : "Pipeline"}:</b>{" "}
				{properties.markerName}
			</p>
			<p hidden={!properties.markerName} key={12}>
				<b>{language === "de" ? "Schilderpfahl" : "Marker Position"}:</b>{" "}
				{properties.markerPosition}
			</p>
			<p hidden={!properties.CH4} key={13}>
				<b>CH4:</b> {properties.CH4}
			</p>
			<p hidden={!properties.rate} key={14}>
				<b>Rate:</b> {properties.rate}
			</p>
			{buttons}
		</span>
	);
}
